import(/* webpackMode: "eager", webpackExports: ["CalculatorPageContent"] */ "/app/apps/web/components/calculators/CalculatorPageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MoonSignCalculatorClient"] */ "/app/apps/web/components/calculators/MoonSignCalculatorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
